// extracted by mini-css-extract-plugin
export default {"heading_stiky":"style_heading_stiky__eRsS3","heading_bordered":"style_heading_bordered__bM3r0","heading":"style_heading__-w21J"};